import "./loginDoctor.scss";
import React, { useState, useContext } from "react";
import { Box, Card, Container, TextField, Typography } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import LoadingButton from "@mui/lab/LoadingButton";
import { loginDoctor } from "../../context/actions/auth/loginDoctor";
import { sendEmailActivateAccount } from "../../context/actions/auth/activateAccount";
import { enqueueSnackbar } from "notistack";
import ModalComponent from "../../components/modal-component";
import { ValidationForm } from "../../components/doctor/validationForm";
import { GlobalContext } from "../../context/Provider";
import { logout, saveEncryptedDataToSessionStorage } from "../../utils";
import { SECRET_KEY } from "../../constants/encriptKey";
import { Isologotipo } from "../../assets/isoLogotipo";

const LoginDoctor = () => {
  const { setUserState } = useContext(GlobalContext);

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [activateAccountData, setActivateAccountData] = useState("");
  const [activateAccount, setActivateAccount] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const [values, setValues] = React.useState({
    showPassword: false,
  });

  const navigate = useNavigate();

  const handleClickRegister = () => {
    navigate("/register");
  };

  const handleClickForgotPassword = () => {
    navigate("/forgot-password");
  };

  const handleClickShowPassword = () => {
    setValues({
      ...values,
      showPassword: !values.showPassword,
    });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const onSubmit = async () => {
    logout()
    setLoading(true);
    try {
      const response = await loginDoctor({
        username: formik.values.email,
        password: formik.values.password,
      });
      setUserState(response.estado.toString())
      // saveEncryptedDataToSessionStorage(response.payload, SECRET_KEY)
      handleOpenModal()
    } catch (error) {
      if (error.errors[0] === "La cuenta no está activada.") {
        setActivateAccountData(error);
        setActivateAccount(true);
        setErrorMessage(
          "La cuenta no esta activada. Por favor presione 'Enviar correo' para recibirlo nuevamente y poder verificarla."
        );
      } else {
        setErrorMessage(error.errors[0] || "Error en el inicio de sesión");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleActivateAccount = async () => {
    setLoading(true);
    try {
      const { result } = activateAccountData;
      const response = await sendEmailActivateAccount(
        result.email,
        result.token
      );
      if (response.result) {
        formik.resetForm();
        setActivateAccount(false);
        setErrorMessage("");
      }
    } catch (error) {
      console.log(error, "activeError");
      enqueueSnackbar(error, { variant: "error" });
    } finally {
      setLoading(false);
    }
  };

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .required("El campo Email es requerido")
        .email("El formato del campo Email es incorrecto")
        .max(100, "El campo Email puede tener hasta 100 caracteres"),

      password: Yup.string()
        // .matches(
        //   /^(?=.*[a-zñüáéíóú])(?=.*[A-ZÑÜÁÉÍÓÚ])(?=.*\d)(?=.*[@$!%*?&'`])[\wñÑüÜáéíóúÁÉÍÓÚ@$!%*?&'`]{8,20}$/,
        //   "La contraseña no cumple con el formato requerido"
        // )
        .required("El campo contraseña es requerido"),
    }),
    onSubmit: (data) => onSubmit(data),
  });
  
  return (
    <Box
      sx={{
        alignItems: "center",
        display: "flex",
        flexGrow: 1,
        marginTop: 20,
      }}
    >
      <Container maxWidth="sm">
        <Card sx={{ padding: "20px", textAlign:"center"}}>
        <Isologotipo/>
          <form onSubmit={formik.handleSubmit}>
            <Box sx={{ my: 1, mt:5 }}>
              <Typography align="center" fontWeight={400} fontSize={30}>
                Ingreso al sistema
              </Typography>
            </Box>
            <Box
              sx={{
                pb: 1,
                pt: 1,
              }}
            >
              <Typography align="center" color="textSecondary" variant="body1">
                Ingrese los datos para acceder a la plataforma
              </Typography>
            </Box>
            <TextField
              error={Boolean(formik.touched.email && formik.errors.email)}
              fullWidth
              helperText={formik.touched.email && formik.errors.email}
              label="Email"
              margin="normal"
              name="email"
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              type="email"
              value={formik.values.email}
              variant="outlined"
            />
            <TextField
              error={Boolean(formik.touched.password && formik.errors.password)}
              fullWidth
              helperText={formik.touched.password && formik.errors.password}
              label="Contraseña"
              margin="normal"
              name="password"
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              type={values.showPassword ? "text" : "password"}
              value={formik.values.password}
              variant="outlined"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {values.showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            {errorMessage && (
              <Typography
                sx={{
                  fontSize: "1rem",
                  fontWeight: "400",
                  textAlign: "center",
                  color: "red",
                }}
              >
                {errorMessage}
              </Typography>
            )}
            <Box sx={{ mt: 2 }}>
              {activateAccount ? (
                <LoadingButton
                  loading={loading}
                  color="primary"
                  fullWidth
                  size="large"
                  variant="contained"
                  type="button"
                  onClick={handleActivateAccount}
                >
                  Enviar correo
                </LoadingButton>
              ) : (
                <LoadingButton
                  loading={loading}
                  color="primary"
                  fullWidth
                  size="large"
                  type="submit"
                  variant="contained"
                  disabled={!formik.isValid}
                >
                  Iniciar sesión
                </LoadingButton>
              )}
            </Box>
            <Box sx={{ mt: 2, display: "flex", justifyContent: "flex-end" }}>
              <a
                href="/forgot-password"
                onClick={(e) => {
                  e.preventDefault();
                  handleClickForgotPassword();
                }}
                className="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedPrimary"
                style={{ marginBottom: "8px", textDecoration: "none" }}
              >
                Olvidó su contraseña?
              </a>
            </Box>
            <Box sx={{ mt: 0, display: "flex", justifyContent: "flex-end" }}>
              <a
                href="/register"
                onClick={(e) => {
                  e.preventDefault();
                  handleClickRegister();
                }}
                className="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedPrimary"
                style={{ textDecoration: "none" }}
              >
                Registro de usuario
              </a>
            </Box>
          </form>
        </Card>
      </Container>
      <ModalComponent open={openModal}  onAcceptText={"Validar"} onCloseText={"Cerrar"} title={"Validar Código"}>
        <ValidationForm onClose={handleCloseModal} userEmail={formik.values.email}/>
      </ModalComponent>
    </Box>
  );
};

export default LoginDoctor;
